module.exports = __webpack_public_path__ + "static/media/select.07c013be.svg";